/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentSharingActor = zod
  .object({
    actorType: zod.enum(['USER', 'SYSTEM', 'GROUP', 'PUBLIC', 'AGENT']),
    firstName: zod.string().nullable(),
    id: zod.string().nullable(),
    lastName: zod.string().nullable(),
    name: zod.string(),
    profileImage: zod
      .object({
        large: zod
          .object({
            contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            url: zod.string().nullable(),
          })
          .nullable(),
        medium: zod
          .object({
            contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            url: zod.string().nullable(),
          })
          .nullable(),
        original: zod
          .object({
            contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            url: zod.string().nullable(),
          })
          .nullable(),
        small: zod
          .object({
            contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            url: zod.string().nullable(),
          })
          .nullable(),
        xsmall: zod
          .object({
            contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            url: zod.string().nullable(),
          })
          .nullable(),
      })
      .nullable(),
    uuid: zod.uuid().describe('UUID v4 identifier'),
  })
  .and(
    zod
      .object({
        email: zod
          .string()
          .nullable()
          .describe(
            'For a USER actor, their email, as getContentSharing gives it. Null for every other actor.',
          ),
      })
      .nullable(),
  )
  .describe(
    'The principal’s display side. Null when it no longer resolves to an actor; the row can still be revoked.',
  );

export type ContentSharingActor = zod.input<typeof ContentSharingActor>;
export type ContentSharingActorOutput = zod.output<typeof ContentSharingActor>;
